module.exports = __webpack_public_path__ + "img/civil.9115f51a.jpg";